/**
 * Reads the Tapatio Tour banner URL from the tenant whitelabel config.
 * The full URL — including the brand ref indicator (e.g. `?ref=SUR`) — is configured
 * per tenant, so the banner only renders for brands that set it.
 * @param {object} [env] - Whitelabel environment config.
 * @returns {string} Configured banner URL, or an empty string when not set.
 */
const getTapatioBannerHref = (env = {}) => {
  const url = env?.tapatioTour?.url;
  return typeof url === 'string' ? url.trim() : '';
};

export default getTapatioBannerHref;
